var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"container-graphics-social-media"},[_c('div',{staticClass:"small-graphics"},[_c('OvertimeLine',{key:'overtimeLine' + _vm.key}),_c('div',{staticClass:"word-and-average"},[_c('WordCloud',{key:'wordCloud' + _vm.key}),_c('AverageByBrand',{key:'averageBrand' + _vm.key})],1)],1),_c('Mentions',{key:'mentions' + _vm.key})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }